// NPM Modules
import React from 'react';
// Components
import UserMenu from '../../components/UserMenu';
/**
 * More Component
 */
export default () => <UserMenu />;
